import * as React from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import { Field } from "formik";
import {
  FieldContainer,
  Fragment,
  PopupBody,
  PopupButton,
  PopupHeader,
  SectionTitle,
  SectionWarning,
} from "./ClassesPopup.styled";
import InputField from "../../../../components/formFields/InputField";
import DatePickerField from "../../../../shared/components/DatePickerField";
import ClassAForm from "./ClassAForm";
import { ClassBForm } from "./ClassBForm";
// import { LoadingPanel } from "../../shared/components/LoadingPanel";

export const ClassesPopup = ({ open, onClose, data, classAPopupOpen, classBPopupOpen }) => {
  console.log(!!data)
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <PopupBody>
        <Fragment>
          <PopupHeader>
            <Box>
              <SectionTitle>{classAPopupOpen ? `${data ? 'Edit' : 'New'} Class A Assessment` : `${data ? 'Edit' : 'New'} Class B Assessment`}</SectionTitle>
            </Box>
            <PopupButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </PopupButton>
          </PopupHeader>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Box>
              <SectionWarning>Edit Assessment will affect all existing invoices for selected premium year.</SectionWarning>
            </Box>
            {classAPopupOpen ? <ClassAForm onClose={onClose} data={data} /> : <ClassBForm onClose={onClose} data={data} />}
          </Box>
        </Fragment>
      </PopupBody>
    </Modal>
  );
};
